module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-bg"
  }, [_c('section', {
    staticClass: "employee-area section-padding zoomIn animated"
  }, [_c('div', {
    staticClass: "container row-li"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', [_vm._v("宜昌艾福斯")]), _vm._v(" "), _vm._l((_vm.aboutList), function(v, i) {
    return _c('ul', {
      key: i,
      staticClass: "mt-4 section-content"
    }, [_c('li', {
      staticClass: "mb-3"
    }, [_vm._v(_vm._s(v.content))])])
  })], 2)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c94c7e7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/About.vue
// module id = 33
// module chunks = 0